<template>
    <div>
        <!-- 支付相关暂时注释->
        <!--<template v-if="tips && (tips.price || tips.title) && this.isPayAble()">-->
        <!--<nav> {{ $t('matchPredictionTip') }} <a class="help" :href="tips.url">?</a></nav>-->
        <!--<article v-if="!tips.title" class="con match-prediction">-->
        <!--<h2>{{ $t('matchPredictionResult') }}</h2>-->
        <!--<a href="" @click.stop.prevent="pay()" class="btn">{{priceText || '$' + tips.price}} {{-->
        <!--$t('matchPredictionView') }}</a>-->
        <!--<p v-if="!isLogin || !tips.free_chance">{{ $t('matchPredictionIncorrect') }}</p>-->
        <!--<p v-else class="free-chance" v-html="$t('matchPredictionFreeChance', {count: tips.free_chance})"></p>-->
        <!--</article>-->
        <!--<article v-else class="con match-prediction-result">-->
        <!--<h2 :class="{'long-title': tips.title.length > 40}">{{ tips.title }}</h2>-->
        <!--<p>{{ tips.content }}</p>-->
        <!--</article>-->
        <!--</template>-->
        <template v-if="match_live && match_live.length">
            <nav>{{$t('broadcast')}}</nav>
            <article class="con">
                <div class="channel-wrap">
                    <span class="channel" v-for="item in match_live" :key="item">{{item}}</span>
                </div>
            </article>
        </template>
        <nav>{{ $t('past_games') }}</nav>
        <article class="con" v-if="battle_history">
            <template v-if="battle_history['list'] && battle_history['list'].length">
                <div class="box">
                    <table>
                        <tbody>
                        <tr>
                            <td class="home">{{ team_A }}</td>
                            <td class="mid">{{$t('pg_lng', {count: battle_history.list.length})}}</td>
                            <td class="away">{{ team_B }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="bar">
                    <table>
                        <tbody>
                        <tr>
                            <td class="win" :style="{width: battle_history['percent']['win'] + '%'}">{{ $tc('pg_w', 10,
                                {count: battle_history['team_A']['win']}) }}
                            </td>
                            <td class="draw" :style="{width: battle_history['percent']['draw'] + '%'}">{{ $tc('pg_d',
                                10, {count: battle_history['team_A']['draw']}) }}
                            </td>
                            <td class="lose" :style="{width: battle_history['percent']['lose'] + '%'}">{{ $tc('pg_w',
                                10, {count: battle_history['team_B']['win']}) }}
                            </td>
                        </tr>
                        </tbody>
                    </table>

                </div>
                <table class="list_1">
                    <tbody>
                    <tr>
                        <th class="date">{{ $t('pg_date') }}</th>
                        <th class="cup">{{ $t('pg_competition') }}</th>
                        <th class="home">{{ $t('pg_home') }}</th>
                        <th class="stat">{{ $t('pg_result') }}</th>
                        <th class="away">{{ $t('pg_away') }}</th>
                    </tr>
                    <tr v-for="(match, num) in battle_history.list" :key="match.match_href" :class="match['color']">
                        <td class="time">
                            <p>{{ match['date'] }}</p>
                            <p>{{ match['year'] }}</p>
                        </td>
                        <td>{{ match['competition'] }}</td>
                        <td :class="{team: match['main_team'] == 'team_A'}">{{ match['team_A_name'] }}</td>
                        <td>
                            <a :href="match['match_href']"> <span class="stat">{{ match['score'] }}</span> </a>
                        </td>
                        <td :class="{team: match['main_team'] == 'team_B'}">{{ match['team_B_name'] }}</td>
                    </tr>
                    </tbody>
                </table>
            </template>
            <div class="none" v-else>{{ $t('pg_no') }}</div>
        </article>
        <template v-if="sideline && sideline.max">
            <nav class="t"> {{ $t('absentee') }} {{sideline.max}}</nav>
            <article class="con">
                <table class="list_3">
                    <tbody>
                    <tr>
                        <th>
                            <img :src="getImgSrc(team_A_logo)" @error="loadDefaultImg" alt=""> {{team_A}}
                        </th>
                        <th>
                            <img :src="getImgSrc(team_B_logo)" @error="loadDefaultImg" alt=""> {{team_B}}
                        </th>
                    </tr>
                    <tr v-for="i in sideline.max" :key="i">
                        <td>
                            <template v-if="sideline['team_A'][i-1]">
                                <span class="num"> {{sideline['team_A'][i-1]['shirtnumber']}}</span>
                                <a :href="sideline['team_A'][i-1]['href']">{{ sideline['team_A'][i-1]['name'] }} </a>
                                <span :class="'reason ' + sideline['team_A'][i-1]['reason']"> {{ sideline['team_A'][i-1]['reason_char'] }} </span>
                            </template>
                        </td>

                        <td>
                            <template v-if="sideline['team_B'][i-1]">
                                <span class="num"> {{sideline['team_B'][i-1]['shirtnumber']}}</span>
                                <a :href="sideline['team_B'][i-1]['href']">{{ sideline['team_B'][i-1]['name'] }} </a>
                                <span :class="'reason ' + sideline['team_B'][i-1]['reason']"> {{ sideline['team_B'][i-1]['reason_char'] }} </span>
                            </template>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </article>
        </template>

        <template v-if="league_table">
            <nav class="t">{{ $t('league_table') }}</nav>
            <article class="con">
                <template v-for="(tables, team) in league_table" v-if="team !== 'name'">
                    <div class="title" :key="team">
                        <img :src="team === 'team_A' ? getImgSrc(team_A_logo) : getImgSrc(team_B_logo)"
                             @error="loadDefaultImg" alt=""> {{
                        team === 'team_A' ? team_A : team_B }}
                    </div>

                    <table :key="tables.name">
                        <tbody>
                        <tr>
                            <th>{{ $t('lt_format') }}</th>
                            <th>{{ $t('lt_p') }}</th>
                            <th>{{ $t('lt_w') }}</th>
                            <th>{{ $t('lt_d') }}</th>
                            <th>{{ $t('lt_l') }}</th>
                            <th>{{ $t('lt_f') }}</th>
                            <th>{{ $t('lt_a') }}</th>
                            <th>{{ $t('lt_pts') }}</th>
                            <th>{{ $t('lt_rank') }}</th>
                            <th>{{ $t('lt_wp') }}</th>
                        </tr>
                        <tr v-for="(table, tabletype) in tables" :key="table.name">
                            <td>{{ $t('lt_' + table['name']) }}</td>
                            <td>{{ table['matches_total'] }}</td>
                            <td>{{ table['matches_won'] }}</td>
                            <td>{{ table['matches_draw'] }}</td>
                            <td>{{ table['matches_lost'] }}</td>
                            <td>{{ table['goals_pro'] }}</td>
                            <td>{{ table['goals_against'] }}</td>
                            <td>{{ table['points'] }}</td>
                            <td>{{ table['rank'] }}</td>
                            <td>{{ table['win_rate'] }}</td>
                        </tr>
                        </tbody>
                    </table>
                </template>
            </article>
        </template>

        <template v-if="cup_table">
            <nav>{{ cup_table['name'] }}</nav>
            <article class="con">
                <table class="list_2">
                    <tbody>
                    <tr>
                        <th class="rank"></th>
                        <th class="name">{{ $t('ct_team') }}</th>
                        <th>{{ $t('ct_p') }}</th>
                        <th>{{ $t('ct_w') }}</th>
                        <th>{{ $t('ct_d') }}</th>
                        <th>{{ $t('ct_l') }}</th>
                        <th>{{ $t('ct_fa') }}</th>
                        <th>{{ $t('ct_pts') }}</th>
                    </tr>

                    <tr v-for="(team, rank) in cup_table.list" :key="rank" :class="{top: team.color == 'green'}">
                        <td>{{ team['rank'] }}</td>
                        <td class="name">
                            <img :src="getImgSrc(team['logo'])" @error="loadDefaultImg" alt=""> {{ team['name'] }}
                        </td>
                        <td>{{ team['matches_total'] }}</td>
                        <td>{{ team['matches_won'] }}</td>
                        <td>{{ team['matches_draw'] }}</td>
                        <td>{{ team['matches_lost'] }}</td>
                        <td>{{ team['goals_pro'] }}/{{ team['goals_against'] }}</td>
                        <td>{{ team['points'] }}</td>
                    </tr>
                    </tbody>
                </table>
            </article>
        </template>

        <nav id="odd">{{ $t('odds') }}
            <!--<a href="javascript:void(0)" @click="scameJump()">{{ $t('more') }}&gt;</a>-->
        </nav>
        <article class="con" id="odd_list" v-if="has_odds">
            <div class="title_1">{{ $t('odds_handicap') }}</div>
            <a href="tab://4">
                <table class="list_4">
                    <tbody>
                    <tr>
                        <th class="company">{{ $t('odds_company') }}</th>
                        <th>{{ $t('odds_type') }}</th>
                        <th>{{ $t('odds_home_lose') }}</th>
                        <th>{{ $t('odds_hdp') }}</th>
                        <th>{{ $t('odds_away_lose') }}</th>
                        <th>{{ $t('odds_tu') }}</th>
                    </tr>
                    <!--asia_companys未知变量-->
                    <!--<tr v-for="asiaCompany in asia_companys" :key="asiaCompany['name']">-->
                        <!--<td class="company">{{Boolean(asiaCompany['name'])?asiaCompany['name']:'-&#45;&#45;'}}</td>-->
                        <!--<td><span class="red">{{ $t('odds_spot') }}</span></td>-->
                        <!--<td>{{Boolean(asiaCompany['now']['homeWin'])?asiaCompany['now']['homeWin']:'-&#45;&#45;'}}</td>-->
                        <!--<td>{{Boolean(asiaCompany['now']['draw'])?asiaCompany['now']['draw']:'-&#45;&#45;'}}</td>-->
                        <!--<td>{{Boolean(asiaCompany['now']['awayWin'])?asiaCompany['now']['awayWin']:'-&#45;&#45;'}}</td>-->
                        <!--<td>{{Boolean(asiaCompany['now']['ts'])?asiaCompany['now']['ts']:'-&#45;&#45;'}}</td>-->
                    <!--</tr>-->
                    </tbody>
                </table>
            </a>
            <div class="title_1">{{ $t('odds_1x2') }}</div>
            <a href="tab://4">
                <table class="list_4">
                    <tbody>
                    <tr>
                        <th class="company">{{ $t('odds_company') }}</th>
                        <th>{{ $t('odds_type') }}</th>
                        <th>{{ $t('odds_home_win') }}</th>
                        <th>{{ $t('odds_draw') }}</th>
                        <th>{{ $t('odds_away_win') }}</th>
                        <th>{{ $t('odds_tu') }}</th>
                    </tr>
                    <tr v-if="aver">
                        <td class="company">{{ $t('odds_average') }}</td>
                        <td><span class="red">{{ $t('odds_spot') }}</span></td>
                        <td>{{Boolean(aver['now']['homeWin'])?aver['now']['homeWin']:'---'}}</td>
                        <td>{{Boolean(aver['now']['draw'])?aver['now']['draw']:'---'}}</td>
                        <td>{{Boolean(aver['now']['awayWin'])?aver['now']['awayWin']:'---'}}</td>
                        <td>{{Boolean(aver['now']['ts'])?aver['now']['ts']:'---'}}</td>
                    </tr>
                    <!--euro_companys未知变量-->
                    <!--<tr v-for="euroCompany in euro_companys" :key="euroCompany['name']">-->
                        <!--<td class="company">{{Boolean(euroCompany['name'])?euroCompany['name']:'-&#45;&#45;'}}</td>-->
                        <!--<td><span class="red">{{ $t('odds_spot') }}</span></td>-->
                        <!--<td>{{Boolean(euroCompany['now']['homeWin'])?euroCompany['now']['homeWin']:'-&#45;&#45;'}}</td>-->
                        <!--<td>{{Boolean(euroCompany['now']['draw'])?euroCompany['now']['draw']:'-&#45;&#45;'}}</td>-->
                        <!--<td>{{Boolean(euroCompany['now']['awayWin'])?euroCompany['now']['awayWin']:'-&#45;&#45;'}}</td>-->
                        <!--<td>{{Boolean(euroCompany['now']['ts'])?euroCompany['now']['ts']:'-&#45;&#45;'}}</td>-->
                    <!--</tr>-->
                    </tbody>
                </table>
            </a>
        </article>
        <div class="none" v-else>{{ $t('odds_no') }}</div>
        <nav>{{ $t('recent_games') }}</nav>
        <article class="con" v-for="(matches, team) in recent_record" :key="team" v-if="team !== 'name'">
            <div class="title t">
                <img :src="team === 'team_A' ? getImgSrc(team_A_logo) : getImgSrc(team_B_logo)" @error="loadDefaultImg"
                     alt=""> {{ team ===
                'team_A' ? team_A : team_B }}
            </div>
            <table class="list_1" v-if="matches && matches.length">
                <tbody>
                <tr>
                    <th class="date">{{ $t('rg_date') }}</th>
                    <th class="cup">{{ $t('rg_competition') }}</th>
                    <th class="home">{{ $t('rg_home') }}</th>
                    <th class="stat">{{ $t('rg_result') }}</th>
                    <th class="away">{{ $t('rg_away') }}</th>
                </tr>

                <tr v-for="(match, id) in matches" :key="id" :class="match['color']">
                    <td class="time">
                        <p>{{ match['date'] }}</p>
                        <p>{{ match['year'] }}</p>
                    </td>
                    <td>{{ match['competition'] }}</td>
                    <td :class="{team: match['main_team'] === 'team_A'}">{{ match['team_A_name'] }}</td>
                    <td><a :href="match['match_href']"><span class="stat">{{ match['score'] }}</span></a></td>
                    <td :class="{team: match['main_team'] === 'team_B'}">{{ match['team_B_name'] }}</td>
                </tr>
                </tbody>
            </table>
            <div class="none" v-else>{{ $t('rg_no') }}</div>
        </article>
        <!--<v-dialog width="80%" :pivot-y="0.1"></v-dialog>-->
    </div>
</template>
<script>
    import defaultTeamImg from '../assets/match/defaultTeam.png';
    import queryString from 'query-string';
    import axios from 'axios';

    export default {
        props: {
            gameData: Object
        },
        data () {
            const data = Object.assign({
                has_odds: null,
                cup_table: null,
                match_live: null,
                battle_history: null,
                sideline: null,
                league_table: null,
                recent_record: null,
                tips: null,
                aver: null,
                priceText: '',
                paybackTimer: null,
                // isLogin: Boolean(window.pageParams.Authorization),
                isLogin: true,
                locale: 'en'
            }, this.gameData);
            return data;
        },
        mounted () {
            const query = queryString.parse(location.search);
            this.locale = query['language'] || query['locale'] || 'en';
            // const me = this;
            // const payback = this.payback.bind(this);

            // window.payback = payback;

            // if (browers.iOS) {
            //     this.$bridge.registerHandler('payback', payback);
            // }

            // axios.get('/api/v2/match/predict_detail', {
            //     params: {
            //         match_id: this.gameData.match_id,
            //         this.locale
            //     }
            // }).then(response => {
            //     let res = response.data;
            //     if (res.errno) {
            //         return;
            //     }
            //     me.tips = res.data;

            // 修改价格为地区性展示
            // const tips = me.tips;

            // if (browers.Android && window.Android && window.Android.getprice) {
            //     window.__setPrice = function (priceText) {
            //         me.priceText = priceText;
            //     };
            //     window.Android.getprice(tips.product && tips.product.and, '__setPrice');
            // } else if (browers.iOS) {
            //     this.$bridge.callHandler('getprice', tips.product && tips.product.ios, function (priceText) {
            //         me.priceText = priceText;
            //     });
            // }
            // });
        },
        methods: {
            loadDefaultImg (event) {
                let dom = event.target;
                dom.src = defaultTeamImg;
            },
            scameJump () {
                // if ((browers.iOS && browers.version >= 282) || (browers.Android && browers.version >= 106)) {
                //     location.href = 'tab://odd';
                // } else if ((browers.iOS && browers.version >= 200 && browers.version < 220) || (browers.Android && browers.version >= 40 && browers.version < 47) || (browers.Android && browers.version === 49)) {
                //     location.href = 'tab://5';
                // } else {
                //     location.href = 'tab://4';
                // }
            },
            isPayAble () {
                if (this.tips.title && this.tips.content) {
                    return true;
                }
                // if ((browers.iOS && browers.version < 240) || (browers.Android && browers.version < 70)) {
                //     return false;
                // }

                // 比赛尚未开始
                if (this.gameData.status && this.gameData.status !== 'Playing' && this.gameData.status !== 'Played') {
                    return true;
                }

                let date = new Date(this.gameData.start_play.replace(/-/g, '/')).getTime();
                let offset = new Date().getTimezoneOffset();
                date = date - offset * 60 * 1000;
                let nowDate = new Date().getTime();

                return (nowDate - date < 60 * 60 * 1000);
            },

            pay () {
                // Todo
            },

            payback () {
                const me = this;

                if (!this.paybackTimer) {
                    this.paybackTimer = setTimeout(() => {
                        me.hideLoading();
                        // Todo
                    }, 15000);
                }

                axios.get('/api/v2/match/predict_detail', {
                    params: {
                        match_id: this.gameData.match_id,
                        _t: (new Date()).getTime()
                    }
                }).then(response => {
                    let res = response.data;
                    if (!res.data || !res.data.title) {
                        setTimeout(me.payback.bind(me), 200);
                        return;
                    }

                    me.paybackTimer && clearTimeout(me.paybackTimer);
                    me.paybackTimer = null;
                    me.hideLoading();

                    me.tips = res.data;
                });
            },

            hideLoading () {
                // 手动取消Loading
                // if (browers.Android) {
                //     window.Android && window.Android.hideLoading();
                // } else if (browers.iOS) {
                //     this.$bridge.callHandler('hideLoading');
                // }
            }
        }
    };
</script>
<style scoped>
    a {
        color: #000;
    }

    html,
    body {
        height: 100%;
    }

    body {
        /*设置英文字体*/
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        background: #eff1f4;
    }

    p,
    div,
    ul,
    ol,
    li {
        margin: 0;
        padding: 0;
    }

    body {
        margin: 0;
        padding: 0;
        -webkit-font-smoothing: antialiased;
        position: relative;
    }

    nav {
        font-size: 14px;
        height: 30px;
        line-height: 30px;
        font-weight: 700;
        color: #333;
        background: #e2e4e6;
        text-align: left;
        padding-left: 16px;
    }

    nav a {
        font-size: 12px;
        float: right;
        margin-right: 5px;
        color: #16ac3a;
        text-decoration: none;
    }

    .t {
        border-bottom: 1px solid #ddd;
        /*no*/
    }

    .con {
        width: 100%;
    }

    .con .channel-wrap {
        font-size: 0;
    }

    .con .channel {
        width: 50%;
        display: inline-block;
        box-sizing: border-box;
        height: 40px;
        border-bottom: 1px solid #ddd; /*px*/
        border-right: 1px solid #ddd; /*px*/
        text-align: center;
        line-height: 40px;
        font-size: 14px;
        color: #333;
        font-weight: bold;
    }

    .con .channel:nth-child(even) {
        border-right: none !important;
    }

    .con .channel:nth-last-child(2):nth-child(odd), .con .channel:last-child {
        border-bottom: none !important;
    }

    .con .title {
        padding: 0 10px;
        background: #eff1f4;
        font-weight: 700;
        color: #333;
        height: 35px;
        line-height: 35px;
        border-bottom: 1px solid #ddd;
    }

    .help {
        display: inline-block;
        width: 14px;
        height: 14px;
        font-size: 0;
        background: url(../assets/match/help.png) no-repeat;
        vertical-align: middle;
        background-size: 100% 100%;
        float: none;
    }

    .con .title_1 {
        padding: 0 10px 0 16px;
        background: #eff1f4;
        font-weight: 700;
        color: #333;
        height: 35px;
        line-height: 35px;
    }

    .con .box {
        background: #eff1f4;
        padding: 10px 10px 5px 10px;
    }

    .con .box table {
        width: 100%;
    }

    .con .box td {
        width: 30%;
        height: auto;
        line-height: 20px;
        font-weight: 700;
        color: #333;
        text-align: left;
        display: inline-block;
        font-size: 14px;
        border: 0;
        background: none;
        vertical-align: text-top;
    }

    .con .box td.mid {
        width: 40%;
        text-align: center;
    }

    .con .box td.away {
        text-align: right;
    }

    div.bar {
        height: 25px;
        line-height: 25px;
        padding: 0 10px 16px 10px;
        border-bottom: 1px solid #ddd;
        /*no*/
    }

    div.bar td {
        color: #fff;
        padding: 0;
        margin: 0;
        border: 0;
        font-size: 12px;
    }

    div.bar .lose {
        background: #f12b2b;
        text-align: right;
        padding-right: 5px;
    }

    div.bar .win {
        background: #49c867;
        text-align: left;
        padding-left: 5px;
    }

    div.bar .draw {
        background: #1d9ff9;
    }

    img {
        width: 20px;
        margin: 0 5px 0 0;
        vertical-align: middle;
    }

    .con .title img {
        width: 20px !important;
        height: auto !important;
        display: inline-block;
    }

    table {
        border-collapse: collapse;
        width: 100%;
        max-width: 100%;
        word-break: break-word;
    }

    table th {
        height: 25px;
        line-height: 1.2;
        vertical-align: middle;
        text-align: center;
        color: #999;
        font-size: 11px;
        border-bottom: 1px solid #ddd;
        /*no*/
        -webkit-transform: scale(0.9);
        transform: scale(0.9);
    }

    table td {
        color: #555;
        height: 30px;
        padding: 3px 0;
        border-bottom: 1px solid #ddd;
        /*no*/
        vertical-align: middle;
        text-align: center;
    }

    table td p {
        line-height: 10px;
        font-size: 10px;
        height: 10px;
        margin: 0;
        padding: 0;
        font-family: arial;
        text-align: center;
        -webkit-transform: scale(0.8);
        transform: scale(0.8);
    }

    div.none {
        height: 55px;
        line-height: 55px;
        text-align: center;
        font-size: 14px;
        color: #999;
    }

    .match-prediction, .match-prediction-result {
        text-align: center;
    }

    .match-prediction h2 {
        font-size: 18px;
        color: #333;
        margin: 20px 0 15px;
    }

    .match-prediction-result h2 {
        font-size: 18px;
        color: #16ac3a;
        margin: 20px 0 15px;
    }

    .match-prediction-result h2.long-title {
        font-size: 14px;
    }

    .match-prediction .btn {
        display: inline-block;
        width: 146px;
        height: 36px;
        color: #fff;
        background-color: #16b13a;
        font-size: 16px;
        text-decoration: none;
        font-weight: bold;
        border-radius: 2px;
        line-height: 36px;
    }

    .match-prediction p, .match-prediction-result p {
        color: #8c9399;
        line-height: 1.4;
        padding: 0 10px;
        margin-bottom: 15px;
    }

    .match-prediction p.free-chance {
        color: #333;
    }

    .match-prediction p.free-chance b {
        color: #16ac3a;
        font-size: 15px;
    }

    .list_1 .date {
        width: 50px;
    }

    .list_1 .cup {
        width: 70px;
    }

    .list_1 .home {
        width: 88px;
    }

    .list_1 .away {
        width: 88px;
    }

    .list_1 .stat {
        width: 24px;
    }

    .list_2 .name {
        text-align: left;
    }

    .list_2 .rank {
        width: 24px;
    }

    .list_2 tr.top td {
        background: #16ac3a;
        color: #fff;
        border-bottom: 1px solid #128a2e;
        /*no*/
    }

    span.stat {
        display: inline-block;
        padding: 0 5px;
        height: 16px;
        line-height: 17px;
        color: #fff;
    }

    tr.lose td.team {
        color: #f12b2b;
    }

    tr.lose td.team a {
        color: #f12b2b;
    }

    tr.lose span.stat {
        background: #f12b2b;
    }

    tr.draw td.team {
        color: #1d9ff9;
    }

    tr.draw td.team a {
        color: #1d9ff9;
    }

    tr.draw span.stat {
        background: #1d9ff9;
    }

    tr.win td.team {
        color: #49c867;
    }

    tr.win td.team a {
        color: #49c867;
    }

    tr.win span.stat {
        background: #49c867;
    }

    .list_3 td,
    .list_3 th {
        border: 1px solid #ddd;
        /*no*/
        padding: 10px 18px 10px 10px;
        height: 20px;
        line-height: 20px;
        text-align: left;
        border-collapse: collapse;
    }

    .list_3 th {
        color: #333;
        font-size: 12px;
        background: #eff1f4;
        -webkit-transform: scale(1);
        transform: scale(1);
    }

    .list_3 td {
        position: relative;
        width: 50%;
    }

    .list_3 td a {
        text-decoration: none;
    }

    .content span.num {
        display: inline-block;
        width: 18px;
        margin: -2px 5px 0 0;
        height: 18px;
        text-align: center;
        line-height: 18px;
        background: #eff1f4;
        vertical-align: middle;
        border-radius: 18px;
        /*border: 1px solid #dfdfdf;*/
        /*no*/
        font-family: arial;
    }

    span.reason {
        position: absolute;
        top: 13px;
        right: 15px;
        width: 16px;
        height: 16px;
        background: #000;
    }

    span.reason_red {
        width: 9px;
        height: 12px;
        border-radius: 2px;
        background: #e20004;
    }

    span.suspension {
        width: 9px;
        height: 12px;
        border-radius: 2px;
        background: #e20004;
    }

    span.reason_yellow {
        width: 9px;
        height: 12px;
        border-radius: 2px;
        background: #f9f115;
    }

    span.reason_injured {
        width: 12px;
        height: 12px;
        border: 1px solid #ddd;
        /*no*/
        background: #eff1f4;
        text-align: center;
        line-height: 12px;
        border-radius: 2px;
        color: #e20004;
        font-size: 12px;
        font-weight: 700;
        font-family: arial;
    }

    span.injury {
        width: 12px;
        height: 12px;
        border: 1px solid #ddd;
        /*no*/
        background: #eff1f4;
        text-align: center;
        line-height: 12px;
        border-radius: 2px;
        color: #e20004;
        font-size: 12px;
        font-weight: 700;
        font-family: arial;
    }

    td.company {
        width: 80px;
    }

    #odd_list a {
        text-decoration: none;
    }

    #odd_list td {
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    /*未知模块*/
    input {
        border: 0;
        margin: 0;
        padding: 0;
        width: 0;
        height: 0;
    }

    nav.tab {
        text-align: center;
        display: block;
        width: 100%;
        background: #eff1f4;
        height: auto;
        padding: 16px 0;
        line-height: 0;
    }

    nav.tab ul {
        display: inline-block;
        border: 1px solid #16ac3a;
        /*no*/
        font-size: 14px;
        border-radius: 2px;
        width: 64%;
        font-size: 0;
        list-style: none;
        padding: 0;
        height: 28px;
    }

    nav.tab li {
        list-style: none;
        display: inline-block;
        width: 50%;
        font-size: 14px;
        line-height: 28px;
        height: 28px;
        color: #16ac3a;
    }

    nav.tab li a {
        display: block;
        color: inherit;
        font-size: inherit;
        text-align: inherit;
        width: 100%;
        padding: 0;
        margin: 0;
    }

    nav.tab li.current {
        background: #16ac3a;
        color: #fff;
    }

    /*dialog*/
    .preview .vue-dialog {
        font-size: 17px;
        top: 20vw !important;
    }

    .preview .vue-dialog .dialog-content {
        padding: 25px;
        font-size: 17px;
        text-align: center;
        line-height: 1.5;
    }

    .preview .vue-dialog-button {
        font-size: 17px !important;
        color: #16ac3a;
        height: 45px;
        line-height: 45px;
        border-radius: 0;
    }
</style>



// WEBPACK FOOTER //
// pastGames.vue?f2bec372